// NAVIGATION
//transparent to white in scrolling
import $ from "jquery";

(function () {
  if (document.getElementById('nav')) {
    const webApp = window.location.pathname.includes('web-app'),
      auth = localStorage.getItem('emailCollect') !== null,
      href = window.location.origin + "/",
      blackFriday = window.location.pathname.includes('black');

    let status = true;

    //Web-app hide sign in (in scroll)
    function webAppButHide() {
      if (webApp && !auth && window.innerWidth >= 1200) {
        if ($(window).scrollTop() >= 60) {
          $('.sign').hide();
        } else {
          $('.sign').show();
        }
      }
    }

    log('Old navigation init');

    function navBackground () {
      if ($(window).scrollTop() >= 60 && status == true) {
        $('.navbar').css('box-shadow', '0 2px 4px 0 rgba(215, 215, 215, 0.5)');
        $('.navbar').css('background', 'white');
        if (webApp && window.innerWidth >= 1280 && !auth) {
          $('.scrollBut').fadeIn();
        }
      } else if (status == true) {
        $('.navbar').css('background', 'transparent');
        $('.navbar').css('box-shadow', 'none');
        if (webApp && window.innerWidth > 1199 && !auth) {
          $('.scrollBut').hide();
        }
      }
    };

    navBackground();

    //Scroll event
    $(window).scroll(function() {
      navBackground();
      webAppButHide();
    });

    //toggler styles
    const nav = document.getElementsByClassName("navbar-toggler")[0];
    const navbar = document.querySelector(".navbar");

    function barTongle() {
      if (window.innerWidth < 1200) {
        navbar.classList.toggle("fixed-top");
      }
    }

    function barToTransp() {
      $('.navbar').css('box-shadow', 'none');
      barTongle();
      adReset();
      navbar.style.backgroundColor = "transparent";
      document.getElementsByClassName('navbar-brand')[0].firstElementChild.src = href + "img/new/dark.svg";
      status = true;
      navbar.style.paddingBottom = "0.5rem";
    }

    function barToWhite() {
      barTongle();
      adReset();
      navbar.style.backgroundColor = "white";
      document.getElementsByClassName('navbar-brand')[0].firstElementChild.src = href + "img/new/dark.svg";
      status = true;
      navbar.style.paddingBottom = "0.5rem";
    }

    let tempScrollTop = 0;

    function adReset() {
      $("body >section , body >main , body >footer").show()
      navbar.classList.toggle('navbar-show');
      if (window.innerWidth < 1200) {
        if (tempScrollTop !== 0) {
          $(window).scrollTop(tempScrollTop);
        }
        navbar.style.height = "";
      }
    }

    $('.navbar-white .dropdown-toggle').on('click', function (e) {
      if (window.innerWidth < 1200) {
        if (!$(this).parent().hasClass("navbar-select")) {
          $('.navbar-white').children().each(function (li) {
            $(this).removeClass('navbar-select');
          });
        }
        $(this).parent().toggleClass('navbar-select');
      }
    });

    nav.addEventListener("click", function() {
      $(".navbar-toggler").addClass('dis');
      setTimeout(function() {
        $(".navbar-toggler").removeClass('dis');
      }.bind(this), 600);
      if (status) {
        navbar.classList.toggle("fixed-top");
        blackFriday ? navWhite (true) : "";
        navbar.classList.toggle('navbar-show');
        $('.navbar').css('box-shadow', '0 2px 4px 0 rgba(215, 215, 215, 0.5)');
        tempScrollTop = $(window).scrollTop();
        $("body >section , body >main , body >footer").hide();
        status = false;
      } else if ($(window).scrollTop() <= 50) {
        barToTransp();
        blackFriday ? navWhite () : "";
      } else {
        barToWhite();
      }
    });

    (function hideNavOnClick() {
      $('.navbar-collapse a').click(function(e) {
        if (!e.target.classList.contains("dropdown-toggle")) {
          if (window.innerWidth < 1200) {
            $('.navbar-collapse').collapse('toggle');
          }
          if ($(window).scrollTop() <= 50) {
            barToTransp();
          } else {
            barToWhite();
          }
        }
      });
    }());

    //Custom menu - radio event

    (function resetCustomTool () {

      $(document).ready(function() {

        const customInputs = document.querySelectorAll('.radioReset input');
        const initInputs = document.getElementsByClassName('radioReset');

        for (let i=0; i<customInputs.length; i++) {
          if (i !== 0 && i !== 3) {
            customInputs[i].checked = false;
          }
        }

        for (let i=0; i<initInputs.length; i++) {
          initInputs[i].firstElementChild.children[0].checked = true;
        }

      });

    }());

    $(".radio-container input").change(function (e) {

      const val = parseInt($(this).val());
      const $parent = $(this).parent().parent();

      function targetBlock (list) {
        return list.each(function (i) {$(this).hide()}).eq(val);
      }

      if ($(this).attr("name") == "custom-tool") {
        targetBlock($parent.next().children()).show();
        targetBlock($parent.next().next().children()).show();
      } else if ($(this).attr("name") == "custom-res") {
        targetBlock($parent.next().children()).css("display", "flex");
      }

    });

    //Custom menu - mouse event
    $('.custom-dropdown').on('mouseenter', function (i) {
      if (window.innerWidth > 1200) {
        $('.navbar').css('background', 'white');
          const $menu = $(this).children().last();
          if ($menu.css('display') == 'none') {
            $('.custom-menu').fadeOut(100);
            $menu.fadeIn(100);
            status = false;
            blackFriday ? navWhite () : "";
          }
          $menu.on('mouseleave', function() {
          if ($(window).scrollTop() <= 50) {
            $('.navbar').css('background', 'transparent');
          }
          $menu.fadeOut(100);
          status = true;
          blackFriday ? navWhite () : "";
        });
      }
    });
  }
}());
